import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { TRACKING } from '../../enums/trackingParts.enum';
import { NetcolognePostcodes } from '../../models/netcolognePostcodes';

@Component({
    selector: 'bdo-netcologne-teaser',
    templateUrl: './netcologne-teaser.component.html',
    styleUrls: ['./netcologne-teaser.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NetcologneTeaserComponent implements OnChanges {
  @Input() postCode: string;
  @Input() trackingLocation: string = TRACKING.LOCATION.NETCOLOGNE_TEASER;
  public isInNetcologneRegion: boolean = false;
  public isRE = true;
  public TRACKING = TRACKING;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.postCode?.currentValue) {
      this.isInNetcologneRegion = NetcolognePostcodes.includes(changes.postCode?.currentValue);
    }
  }

}
